(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
const aboutFilmCleanups = new Map();
function initializeAboutFilm(scope) {
  for (const panel of scope.querySelectorAll('.wo-about-content')) {
    const section = panel.closest('.shopify-section');
    const video = section?.querySelector('.wo-about-film video');
    const button = panel.querySelector('.wo-about-film-toggle');
    if (!video || !button || aboutFilmCleanups.has(section)) continue;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    let inView = false;
    video.muted = true;
    const updateControl = () => {
      button.dataset.paused = String(video.paused);
      button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    };
    const syncPlayback = () => {
      if (motion.matches || document.hidden || !inView || userPaused) {
        video.pause();
      } else {
        video.play().catch(() => { updateControl(); });
      }
    };
    button.addEventListener('click', () => { userPaused = !video.paused; syncPlayback(); }, options);
    video.addEventListener('play', updateControl, options);
    video.addEventListener('pause', updateControl, options);
    motion.addEventListener('change', syncPlayback, options);
    document.addEventListener('visibilitychange', syncPlayback, options);
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      syncPlayback();
    }, { threshold: .01 });
    observer.observe(section);
    aboutFilmCleanups.set(section, () => { video.pause(); observer.disconnect(); controller.abort(); });
    button.hidden = false;
    updateControl();
  }
}
initializeAboutFilm(document);
document.addEventListener('shopify:section:load', event => { initializeAboutFilm(event.target); });
document.addEventListener('shopify:section:unload', event => {
  for (const [section, cleanup] of aboutFilmCleanups) {
    if (event.target === section || event.target.contains(section)) {
      cleanup();
      aboutFilmCleanups.delete(section);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omen-crawl"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('.omen-crawl__pause');
  if (!button) return;
  const paused = button.getAttribute('aria-pressed') !== 'true';
  button.setAttribute('aria-pressed', String(paused));
  button.closest('.omen-crawl').classList.toggle('is-paused', paused);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omen-home"] && !Shopify.designMode) return;
  try {
    
function initializeOmenFilm(scope) {
  scope.querySelectorAll('.omen-hero-copy, .omen-campaign-video').forEach(function(panel) {
    const video = panel.querySelector('video');
    const button = panel.querySelector('.omen-film-toggle');
    if (!video || !button || video.dataset.omenReady) return;
    video.dataset.omenReady = 'true';
    video.muted = true;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 749px)');
    let userStarted = false;
    let userPaused = false;
    let inView = false;
    function updateControl() {
      button.dataset.paused = String(video.paused);
      button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    }
    function syncPlayback() {
      if (motion.matches || document.hidden || !inView || userPaused || (mobile.matches && !userStarted)) {
        video.pause();
      } else {
        video.play().catch(function(error) {
          if (error.name !== 'AbortError') userPaused = true;
          updateControl();
        });
      }
    }
    button.addEventListener('click', function() {
      userStarted = true;
      userPaused = !video.paused;
      syncPlayback();
    });
    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    motion.addEventListener('change', syncPlayback);
    mobile.addEventListener('change', syncPlayback);
    document.addEventListener('visibilitychange', syncPlayback);
    new IntersectionObserver(function(entries) {
      inView = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold: .05}).observe(panel);
    button.hidden = false;
    updateControl();
  });
}
initializeOmenFilm(document);
document.addEventListener('shopify:section:load', function(event) { initializeOmenFilm(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wo-skate-collection"] && !Shopify.designMode) return;
  try {
    
function initializeSkateFilm(scope) {
  scope.querySelectorAll('.wo-skate__catalogue--film,.wo-skate__opening--film').forEach(function(panel) {
    const video = panel.querySelector('.wo-skate__film video');
    const button = panel.querySelector('.wo-skate__film-toggle');
    if (!video || !button || video.dataset.skateFilmReady) return;
    video.dataset.skateFilmReady = 'true';
    video.muted = true;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 749px)');
    let userStarted = false;
    let userPaused = false;
    let inView = false;
    function updateControl() {
      button.dataset.paused = String(video.paused);
      button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    }
    function syncPlayback() {
      if (motion.matches || document.hidden || !inView || userPaused || (mobile.matches && !userStarted)) {
        video.pause();
      } else {
        video.play().catch(function() { userPaused = true; updateControl(); });
      }
    }
    button.addEventListener('click', function() {
      userStarted = true;
      userPaused = !video.paused;
      syncPlayback();
    });
    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    motion.addEventListener('change', syncPlayback);
    mobile.addEventListener('change', syncPlayback);
    document.addEventListener('visibilitychange', syncPlayback);
    new IntersectionObserver(function(entries) {
      inView = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold: 0}).observe(panel);
    button.hidden = false;
    updateControl();
  });
}
initializeSkateFilm(document);
document.addEventListener('shopify:section:load', function(event) { initializeSkateFilm(event.target); });

  } catch(e) { console.error(e); }
})();
})();
